import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';

const PluginDeleteModal = ({ isOpen, onClose, onConfirm, plugin, submitting }) => {
  const { t } = useTranslation();
  if (!isOpen || !plugin) return null;

  const handleBackdropClick = () => {
    if (!submitting) onClose();
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div
        className="modal-content max-w-md"
        onClick={(e) => e.stopPropagation()}
        data-testid="plugin-delete-modal"
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-100 text-red-700 rounded-lg flex items-center justify-center">
              <AlertTriangle className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-bold text-gray-900">
              {t('plugins.confirmDeleteTitle')}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={submitting}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-gray-600 mb-6 leading-relaxed">
          <Trans
            i18nKey="plugins.confirmDeleteMessage"
            values={{ name: plugin.name, displayId: plugin.displayId }}
            components={{ strong: <strong className="font-semibold text-gray-900" /> }}
          />
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={submitting}
            className="btn-secondary"
          >
            {t('plugins.confirmDeleteCancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {submitting ? (
              <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : null}
            {t('plugins.confirmDeleteConfirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PluginDeleteModal;